import { GridApi, GridReadyEvent, SelectionChangedEvent } from "ag-grid-community";
import _ from "lodash";
import { action, makeObservable, observable } from "mobx";
import ProjectStakeholdersApi, {
  ProjectStakeholdersApi as IProjectStakeholdersApi
} from "../../../../services/api/v2/projectStakeholders/ProjectStakeholders.api";
import ProjectStakeholdersHub, {
  ProjectStakeholdersHub as IProjectStakeholdersHub
} from "../../../../services/hubs/ProjectStakeholdersHub/ProjectStakeholders_hub";

export class StakeholderGridModel {
  projectId: number;
  projectStakeholdersHub: IProjectStakeholdersHub;
  organisationId: number;
  @observable isLoading: boolean = true;
  @observable gridStakeholders: FP.Entities.IImpactSummary[];
  authUser: FP.Entities.IUser;
  @observable.ref selectedStakeholders: number[] = [];
  gridApi: GridApi;
  projectStakeholderProvider: IProjectStakeholdersApi;
  searchText: string;

  /**
   *
   */
  constructor(projectId: number, organisationId: number, authUser: FP.Entities.IUser) {
    makeObservable(this);
    this.projectId = projectId;
    this.projectStakeholdersHub = ProjectStakeholdersHub;
    this.projectStakeholderProvider = ProjectStakeholdersApi;
    this.organisationId = organisationId;
    this.authUser = authUser;
  }

  onMount = async () => {
    await this.registerSocketEvents();
  };

  onUnmount = () => {
    this.projectStakeholdersHub.stopConnection();
  };

  registerSocketEvents = async () => {
    if (this.projectStakeholdersHub.isConnectionStarted === true) {
      await this.projectStakeholdersHub.stopConnection();
    }
    await this.projectStakeholdersHub.startConnection();

    this.projectStakeholdersHub.onLoadData(d => {
      this.setStakeholderRowData(d.data);
    });

    await this.projectStakeholdersHub.invokeLoadData(this.organisationId, this.projectId);
  };

  @action
  setStakeholderRowData = stakeholders => {
    this.setGridStakeholders(stakeholders);
    this.isLoading = false;
  };

  @action
  setGridStakeholders = stakeholders => {
    this.gridStakeholders = stakeholders;
  };

  @action
  onGridReady = (gridReadyEvent: GridReadyEvent) => {
    this.gridApi = gridReadyEvent.api;
  };

  @action
  setSearchText = (ev: React.FormEvent<HTMLInputElement>) => {
    this.searchText = ev.currentTarget.value;

    if (this.gridApi !== undefined) {
      this.gridApi.setGridOption("quickFilterText", this.searchText);
    }
  };

  @action
  updateSelectedStakeholders = (event: SelectionChangedEvent) => {
    this.gridApi = event.api;
    this.selectedStakeholders = _.map(event.api.getSelectedNodes(), e => {
      return e.data.id;
    });
  };
}
